export enum pollInterval {
  FIFTEEN_SEC = 15000
}
